import { IResponseProps } from '@/entities/Response'
import { IMessageProps } from '@/entities/Message'

export const Types = {
  store: 'store',
  current: 'current',
  filter: 'filter'
}

export const path = 'message/'

export class Store implements FluxStandardAction<IResponseProps<IMessageProps>> {
  type = path + Types.store
  constructor(public payload: IResponseProps<IMessageProps>) {}
}

export class Current implements FluxStandardAction<IMessageProps | null> {
  type = path + Types.current
  constructor(public payload: IMessageProps | null) {}
}

export class Filter implements FluxStandardAction<string> {
  type = path + Types.filter
  constructor(public payload: string) {}
}
